module.exports = "<!--<app-basic-info></app-basic-info>-->\n<router-outlet></router-outlet>\n<div class=\"container\">\n  <footer>\n    <p class=\"float-right\"><a href=\"\">Back to Main</a></p>\n    <p> Designed and Developed by 7PixelsIndia. &copy; 2017 eCell@HCST, Inc.</p>\n  </footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/Projects/angular/ecell-hcst/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1